import axios from 'axios';
import i18n from '../../language/i18n';

const LAST_MONTH_OF_YEAR = 12;

const getMonthId = (monthIndex) => {
  const month = new Date().getMonth() + monthIndex + 1;
  return new Promise((resolve, reject) => {
    axios
      .get('rest/v4/monthOfEmployees', {
        params: {
          month: month == 0 ? LAST_MONTH_OF_YEAR : month,
          year: month == 0 ? new Date().getFullYear()-1 : new Date().getFullYear()
        }
      })
      .then(response => {
        resolve(response.data?.data[0]?.id);
      })
      .catch(err => {
        reject(err);
      });
  });
};

const labelMapperProductivity = (item) => {
  return item.isProductive ?
      i18n.t('Common.productive') :
      i18n.t('Common.unproductive')
};

const getCurrentMonth = () => getMonthId(1);
const getLastMonth = () => getMonthId(0);

const MONTH_CAPPING_HEADERS= Object.freeze([
  {
    text: 'Dashboard.widgets.monthCappingProjectHours.headers.reason',
    value: 'reason'
  },
  { text: 'Dashboard.widgets.monthCappingProjectHours.headers.time', value: 'time' }
])

const MONTH_WIDGETS = Object.freeze({
  MONTH_OF_EMPLOYEES_WIDGETS: [
    {
      id: 'monthTimeProjectHoursCurrent',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getCurrentMonth,
      getData: response => response.data.data.projectHoursStatisticData,
      type: 'CHART',
      defaultChartType: 'DOUGHNUT',
      legendLabel: 'projectLabel',
      suffix: 'workingTime'
    },
    {
      id: 'monthTimeProjectHoursLast',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getLastMonth,
      getData: response => response.data.data.projectHoursStatisticData,
      type: 'CHART',
      defaultChartType: 'DOUGHNUT',
      legendLabel: 'projectLabel',
      suffix: 'workingTime'
    },
    {
      id: 'monthProjectProductivityDiagramCurrent',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getCurrentMonth,
      getData: response => response.data.data.projectProductivityStatisticData,
      labelMapper: labelMapperProductivity,
      type: 'CHART',
      defaultChartType: 'DOUGHNUT'
    },
    {
      id: 'monthProjectProductivityDiagramLast',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getLastMonth,
      getData: response => response.data.data.projectProductivityStatisticData,
      labelMapper: labelMapperProductivity,
      type: 'CHART',
      defaultChartType: 'DOUGHNUT'
    },
    {
      id: 'monthProjectHoursBalanceDataCurrent',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getCurrentMonth,
      getData: response => response.data.data.balanceData,
      type: 'KEY_VALUE'
    },
    {
      id: 'monthProjectHoursBalanceDataLast',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getLastMonth,
      getData: response => response.data.data.balanceData,
      type: 'KEY_VALUE'
    },
    {
      id: 'monthActualHoursCurrent',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getCurrentMonth,
      getData: response => response.data.data.actualData?.workingTime,
      type: 'VALUE'
    },
    {
      id: 'monthActualHoursLast',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getLastMonth,
      getData: response => response.data.data.actualData?.workingTime,
      type: 'VALUE'
    },
    {
      id: 'monthCappingProjectHoursCurrent',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getCurrentMonth,
      getData: response => response.data.data.cappingData?.items,
      type: 'TABLE',
      headers: MONTH_CAPPING_HEADERS,
      withRouterActionLink: false
    },
    {
      id: 'monthCappingProjectHoursLast',
      moduleId: 'monthOfEmployees',
      path: 'monthOfEmployees',
      pathParameter: getCurrentMonth,
      getData: response => response.data.data.cappingData?.items,
      type: 'TABLE',
      headers: MONTH_CAPPING_HEADERS,
      withRouterActionLink: false
    }
  ]
});

export default MONTH_WIDGETS;
